<template>
  <div>
    <jet-banner />
    <div class="md:flex h-screen overflow-y-hidden bg-gray-800">
      <Sidebar :url="url()" />

      <div class="flex flex-col flex-1 h-full overflow-hidden">
        <Navbar />

        <!-- Page Heading -->
        <header class="bg-gray-800  text-white border-b border-gray-400 w-full p-4">
            <slot name="header" class="text-white"></slot>
        </header>

        <!-- Page Content -->
        <main class="flex-1 max-h-full p-5 overflow-hidden overflow-y-scroll">
          <slot></slot>
        </main>

        <Footer /> 
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/Layouts/Navbar";
import Sidebar from "@/Layouts/Sidebar";
import Footer from "@/Layouts/Footer";
import JetApplicationMark from "@/Jetstream/ApplicationMark";
import JetBanner from "@/Jetstream/Banner";
import JetDropdown from "@/Jetstream/Dropdown";
import JetDropdownLink from "@/Jetstream/DropdownLink";
import JetNavLink from "@/Jetstream/NavLink";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink";

export default {
  components: {
    Navbar,
    Sidebar,
    Footer,
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
  },

  data() {
    return {
      showingNavigationDropdown: false,
    };
  },

  methods: {
    url() {
      return location.pathname.substr(1);
    },
    switchToTeam(team) {
      this.$inertia.put(
        route("current-team.update"),
        {
          team_id: team.id,
        },
        {
          preserveState: false,
        }
      );
    },

    logout() {
      this.$inertia.post(route("logout"));
    },
  },
};
</script>